import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { AvailabilitySort } from "./component";
import { getHotelAvailabilitySortOption } from "../../reducer";
import { setHotelAvailabilitySortOption } from "../../actions/actions";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => {
  return {
    sortOption: getHotelAvailabilitySortOption(state),
  };
};

const mapDispatchToProps = {
  setHotelAvailabilitySortOption,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AvailabilitySortConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedAvailabilitySort = withRouter(
  connector(AvailabilitySort)
);
